var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-sm p-5 m-auto"},[_c('h2',{staticClass:"mb-4 text-xl font-bold text-center"},[_vm._v("Register")]),_c('RegisterForm',{staticClass:"p-5 bg-white border rounded shadow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }